import React from 'react';

interface UserAvatarProps {
  initials?: string;
  color1?: string;
  color2?: string;
}

const UserAvatar = ({ initials, color1, color2 }: UserAvatarProps) => (
    <div className="w-14 h-14 rounded-full border-2 border-white shadow-md flex-shrink-0">
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id={`grad-${initials || '?'}`} x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{stopColor: color1, stopOpacity:1}} />
                    <stop offset="100%" style={{stopColor: color2, stopOpacity:1}} />
                </linearGradient>
            </defs>
            <circle cx="50" cy="50" r="50" fill={`url(#grad-${initials || '?'})`} />
            <text x="50" y="50" textAnchor="middle" dy=".3em" fill="white" fontSize="40" fontWeight="bold">{initials || '?'}</text>
        </svg>
    </div>
);

export default UserAvatar;
